import React from "react";
import { AdminContainer } from "../components/layouts";
import MaterialTable from "material-table";
import { useTheme } from "@material-ui/core/styles";
import Time from "../lithic/Moment";
import api from "../api";
import displayPhone from "../modules/displayPhone";
import tableIcons from "../components/tableIcons";
import {
  apiCollectionToRowResponse,
  rowQueryToApiParams
} from "../modules/tableQuery";
import { renderTableLink } from "../components/renderTableCell";
import debounce from "lodash/debounce";

export default function CustomersListPage() {
  const theme = useTheme();
  const tableRef = React.createRef();
  const lastQueryRef = React.useRef("");

  const columns = React.useMemo(() => makeColumns(), []);

  const fetchData = React.useCallback(
    debounce((q, resolve) => {
      const queryStr = JSON.stringify(q);
      if (lastQueryRef.current === queryStr) return resolve([]);
      lastQueryRef.current = queryStr;

      api
        .getCustomers(rowQueryToApiParams(q))
        .then((resp) => resolve(apiCollectionToRowResponse(resp)));
    }, 300),
    []
  );

  return (
    <AdminContainer variant="list">
      <MaterialTable
        title="Customers"
        tableRef={tableRef}
        columns={columns}
        options={{
          emptyRowsWhenPaging: false,
          pageSize: 50,
          pageSizeOptions: [50],
          sorting: true,
          thirdSortClick: false
        }}
        data={(q) =>
          new Promise((resolve) => {
            fetchData(q, resolve);
          })
        }
        icons={tableIcons}
      />
    </AdminContainer>
  );
}

function makeColumns() {
  return [
    {
      title: "Id",
      field: "id",
      defaultSort: "desc",
      width: 20,
      render: renderTableLink({ url: "/customers/", body: "id" })
    },
    {
      title: "Email",
      field: "email",
      defaultSort: "asc",
      render: renderTableLink({ url: "/customers/", body: "email" })
    },
    {
      title: "Name",
      field: "name",
      sorting: false,
      render: renderTableLink({ url: "/customers/", body: "name" })
    },
    {
      title: "Phone",
      field: "phone",
      defaultSort: "asc",
      render: renderTableLink({
        url: "/customers/",
        body: (rowData) => displayPhone(rowData.phone)
      })
    },
    {
      title: "Created",
      field: "createdAt",
      defaultSort: "desc",
      render: renderTableLink({
        url: "/customers/",
        body: (rowData) => (
          <Time formatExact="MMM DD, YYYY" timezone={rowData.timezone}>
            {rowData.createdAt}
          </Time>
        )
      })
    }
  ];
}
